const targetType = {
  COMMUNITY: 13, // 小区
  PROJECT: 3, // 工地
  CASE: 6, // 案例
  PROMOTION: 8, // 促销
  ACTIVITY: 16, // 活动类型
  PRODUCT: 9, // 产品
  COMPMEMBER: 10, // 成员
  VR_CASE: 7,
  PROJECTUPDATE: 17, // 更新
  SERVICE: 11, // 服务
  SERVICELANDING: 26, // 预约落地页
  // special
  SERVICE_DYNAMICS: 201, // 服务动态

  AGENT_AFFILIATES_PROJECT: 23,
  // level 1 page
  COMPANY: 12, // 公司
  ABOUT_PAGE: 101,

  // list page
  PROJECT_LIST: 103,
  TEAM_PAGE: 104,
  CASE_LIST: 105,
  PRODUCT_LIST: 106,
  PROMOTION_LIST: 107,

  SOFT_ARTICLE: 30, // 软文

  // misc
  YQZ_APP: 100,
  VIDEO: 32 // 视频
}

export default targetType
